<html>
<body>
  <div class="manage-billing-text">
   Please click <a (click)="openManageBillingWidget()" target="_blank">here</a> to manage billing.
  </div>
</body>
</html>